"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _intl = require("@kyruus/intl");
var _menu = _interopRequireDefault(require("@kyruus/menu"));
var _Share = _interopRequireDefault(require("@kyruus/react-ikons/Share"));
var _print = require("./print");
var _email = require("./email");
var _facebook = require("./facebook");
var _twitterX = require("./twitter-x");
var _profileLink = require("./profileLink");
var _style = require("./style");
var _messages = _interopRequireDefault(require("./lib/messages"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Print and share a url on social in a react component
 */
const SocialShareMenu = _ref => {
  let {
    url,
    text,
    showPrint = true,
    showEmail = true,
    showFacebook = true,
    showTwitterX = true,
    showLabels = true,
    onProfileLinkClick = () => {},
    onClick = () => {},
    onOpen = () => {},
    onClose = () => {},
    showAriaLabels = true,
    intl
  } = _ref;
  const [socialShareMenuAnchor, setSocialShareMenuAnchor] = (0, _react.useState)(null);
  const handleClickOpenSocialShareMenu = e => {
    if (onOpen) {
      onOpen();
    }
    setSocialShareMenuAnchor(e.currentTarget);
  };
  const handleCloseSocialShare = () => {
    if (onClose) {
      onClose();
    }
    setSocialShareMenuAnchor(null);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_style.ShareMenuButton, {
    onClick: handleClickOpenSocialShareMenu
  }, /*#__PURE__*/_react.default.createElement("span", null, intl.formatMessage(_messages.default.share)), /*#__PURE__*/_react.default.createElement(_Share.default, {
    size: '21px',
    "aria-hidden": "true",
    title: "",
    "data-testid": "share-svg"
  })), /*#__PURE__*/_react.default.createElement(_menu.default, {
    elevation: 2,
    anchorEl: socialShareMenuAnchor,
    open: Boolean(socialShareMenuAnchor),
    onClose: handleCloseSocialShare,
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    }
  }, showPrint && /*#__PURE__*/_react.default.createElement(_print.PrintShareMenuItem, {
    url: url,
    text: text,
    label: intl.formatMessage(_messages.default.print),
    showLabel: showLabels,
    onClick: onClick,
    "aria-label": showAriaLabels ? intl.formatMessage(_messages.default.printAriaLabel) : null
  }), showEmail && /*#__PURE__*/_react.default.createElement(_email.EmailShareMenuItem, {
    url: url,
    text: text,
    label: intl.formatMessage(_messages.default.email),
    showLabel: showLabels,
    onClick: onClick,
    "aria-label": showAriaLabels ? intl.formatMessage(_messages.default.emailAriaLabel) : null
  }), showFacebook && /*#__PURE__*/_react.default.createElement(_facebook.FacebookShareMenuItem, {
    url: url,
    text: text,
    label: intl.formatMessage(_messages.default.facebook),
    showLabel: showLabels,
    onClick: onClick,
    "aria-label": showAriaLabels ? intl.formatMessage(_messages.default.facebookAriaLabel) : null
  }), showTwitterX && /*#__PURE__*/_react.default.createElement(_twitterX.TwitterXShareMenuItem, {
    url: url,
    text: text,
    label: intl.formatMessage(_messages.default.twitterX),
    showLabel: showLabels,
    onClick: onClick,
    "aria-label": showAriaLabels ? intl.formatMessage(_messages.default.twitterXAriaLabel) : null
  }), /*#__PURE__*/_react.default.createElement(_profileLink.ProfileLinkShareMenuItem, {
    url: url,
    text: text,
    label: intl.formatMessage(_messages.default.profileLink),
    showLabel: showLabels,
    onProfileLinkClick: onProfileLinkClick,
    "aria-label": showAriaLabels ? intl.formatMessage(_messages.default.profileLinkAriaLabel) : null
  })));
};
SocialShareMenu.propTypes = {
  /**
   * The url of the page you want to share.
   */
  url: _propTypes.default.string.isRequired,
  /**
   * The text that will form the subject line of the email or the text of the tweet or post.
   */
  text: _propTypes.default.string.isRequired,
  /**
   * Show the print menu item
   */
  showPrint: _propTypes.default.bool,
  /**
   * Show the email menu item
   */
  showEmail: _propTypes.default.bool,
  /**
   * Show the Facebook menu item
   */
  showFacebook: _propTypes.default.bool,
  /**
   * Show the X menu item
   */
  showTwitterX: _propTypes.default.bool,
  /**
   * Determines whether or not the visible labels are rendered (as opposed to just the icons)
   */
  showLabels: _propTypes.default.bool,
  /**
   * Called before the the onClick is executed for the menu list item. Called with the type of event ('print', 'facebook' etc.).
   */
  onClick: _propTypes.default.func,
  /**
   * Called when the menu is opened.
   */
  onOpen: _propTypes.default.func,
  /**
   * Called when the menu is closed.
   */
  onClose: _propTypes.default.func,
  /**
   * Where or not to show the aria-label attribute on the buttons
   */
  showAriaLabels: _propTypes.default.bool,
  /**
   * The injected intl
   */
  intl: _propTypes.default.object,
  /**
   * Called when the profile menu is clicked.
   */
  onProfileLinkClick: _propTypes.default.func
};
var _default = exports.default = (0, _intl.injectIntl)(SocialShareMenu);
SocialShareMenu.__docgenInfo = {
  "description": "Print and share a url on social in a react component",
  "methods": [],
  "displayName": "SocialShareMenu",
  "props": {
    "showPrint": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Show the print menu item",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "showEmail": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Show the email menu item",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "showFacebook": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Show the Facebook menu item",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "showTwitterX": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Show the X menu item",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "showLabels": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Determines whether or not the visible labels are rendered (as opposed to just the icons)",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onProfileLinkClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "Called when the profile menu is clicked.",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "Called before the the onClick is executed for the menu list item. Called with the type of event ('print', 'facebook' etc.).",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onOpen": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "Called when the menu is opened.",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onClose": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "Called when the menu is closed.",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "showAriaLabels": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Where or not to show the aria-label attribute on the buttons",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "url": {
      "description": "The url of the page you want to share.",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "text": {
      "description": "The text that will form the subject line of the email or the text of the tweet or post.",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "intl": {
      "description": "The injected intl",
      "type": {
        "name": "object"
      },
      "required": false
    }
  }
};